import { useEffect, useRef } from "react";
import { renderAdminContent } from "./admin-view.js";
import { repairDomText } from "../../utils/dom.js";

// Admin sections that have not been migrated to components yet. React owns the
// shell and this node; the legacy renderer owns everything inside it.
export default function LegacyAdminContent({ section, detailId, revision, navigate }: {
  section: string; detailId?: string; revision: number; navigate: (path: string) => void;
}) {
  const mount = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!mount.current) return;
    renderAdminContent(mount.current, section, detailId, navigate);
    repairDomText(mount.current);
  }, [section, detailId, revision, navigate]);

  return <div ref={mount} />;
}
